import type { Locale } from 'antd/es/locale'
import frFR from 'antd/locale/fr_FR'
import en_GB from 'antd/locale/en_GB'
import es_ES from 'antd/locale/es_ES'
import de_DE from 'antd/locale/de_DE'
import pt_PT from 'antd/locale/pt_PT'
import pt_BR from 'antd/locale/pt_BR'
import it_IT from 'antd/locale/it_IT'
import zh_CN from 'antd/locale/zh_CN'
import ru_RU from 'antd/locale/ru_RU'
import el_GR from 'antd/locale/el_GR'
import sr_SP from 'antd/locale/sr_RS'
import lv_LV from 'antd/locale/lv_LV'
import lt_LT from 'antd/locale/lt_LT'
import et_EE from 'antd/locale/et_EE'
import bg_BG from 'antd/locale/bg_BG'
import km_KH from 'antd/locale/km_KH'
import ja_JP from 'antd/locale/ja_JP'
import uk_UA from 'antd/locale/uk_UA'
import vi_VN from 'antd/locale/vi_VN'
import nl_NL from 'antd/locale/nl_NL'
import pl_PL from 'antd/locale/pl_PL'
import cs_CZ from 'antd/locale/cs_CZ'
import sk_SK from 'antd/locale/sk_SK'
import hu_HU from 'antd/locale/hu_HU'
import ro_RO from 'antd/locale/ro_RO'
import hr_HR from 'antd/locale/hr_HR'
import ms_MY from 'antd/locale/ms_MY'
import fr_CA from 'antd/locale/fr_CA'
import no_NO from 'antd/locale/nb_NO'
import tr_TR from 'antd/locale/tr_TR'
import nl_BE from 'antd/locale/nl_BE'
import kk_KZ from 'antd/locale/kk_KZ'
import id_ID from 'antd/locale/id_ID'
import ko_KR from 'antd/locale/ko_KR'

import type { SupportedLanguage } from '../../../shared/i18n/types.no-deps'
import { assumeExhaustion } from '../../../shared/lib/typeHelpers.no-deps'

const fil_PH: Locale = {
    locale: 'fil_PH',
    Pagination: {
        items_per_page: '/ pahina',
        jump_to: 'Pumunta sa',
        jump_to_confirm: 'kumpirmahin',
        page: 'Pahina',
        prev_page: 'Nakaraang Pahina',
        next_page: 'Susunod na Pahina',
        prev_5: 'Nakaraang 5 Pahina',
        next_5: 'Susunod na 5 Pahina',
        prev_3: 'Nakaraang 3 Pahina',
        next_3: 'Susunod na 3 Pahina',
        page_size: 'Laki ng Pahina',
    },
    DatePicker: {
        lang: {
            placeholder: 'Pumili ng petsa',
            yearPlaceholder: 'Pumili ng taon',
            quarterPlaceholder: 'Pumili ng quarter',
            monthPlaceholder: 'Pumili ng buwan',
            weekPlaceholder: 'Pumili ng linggo',
            rangePlaceholder: ['Simulang petsa', 'Pangwakas na petsa'],
            rangeYearPlaceholder: ['Simulang taon', 'Pangwakas na taon'],
            rangeQuarterPlaceholder: ['Simulang quarter', 'Pangwakas na quarter'],
            rangeMonthPlaceholder: ['Simulang buwan', 'Pangwakas na buwan'],
            rangeWeekPlaceholder: ['Simulang linggo', 'Pangwakas na linggo'],
            locale: 'fil_PH',
            today: 'Ngayon',
            now: 'Ngayon',
            backToToday: 'Bumalik sa ngayon',
            ok: 'OK',
            clear: 'Burahin',
            month: 'Buwan',
            year: 'Taon',
            timeSelect: 'Pumili ng oras',
            dateSelect: 'Pumili ng petsa',
            monthSelect: 'Pumili ng buwan',
            yearSelect: 'Pumili ng taon',
            decadeSelect: 'Pumili ng dekada',
            yearFormat: 'YYYY',
            dateFormat: 'D/M/YYYY',
            dayFormat: 'D',
            dateTimeFormat: 'D/M/YYYY HH:mm:ss',
            monthBeforeYear: true,
            previousMonth: 'Nakaraang buwan (PageUp)',
            nextMonth: 'Susunod na buwan (PageDown)',
            previousYear: 'Nakaraang taon (Control + kaliwa)',
            nextYear: 'Susunod na taon (Control + kanan)',
            previousDecade: 'Nakaraang dekada',
            nextDecade: 'Susunod na dekada',
            previousCentury: 'Nakaraang siglo',
            nextCentury: 'Susunod na siglo',
        },
        timePickerLocale: { placeholder: 'Pumili ng oras' },
    },
    TimePicker: { placeholder: 'Pumili ng oras' },
    Calendar: {
        lang: {
            placeholder: 'Pumili ng petsa',
            yearPlaceholder: 'Pumili ng taon',
            quarterPlaceholder: 'Pumili ng quarter',
            monthPlaceholder: 'Pumili ng buwan',
            weekPlaceholder: 'Pumili ng linggo',
            rangePlaceholder: ['Simulang petsa', 'Pangwakas na petsa'],
            rangeYearPlaceholder: ['Simulang taon', 'Pangwakas na taon'],
            rangeQuarterPlaceholder: ['Simulang quarter', 'Pangwakas na quarter'],
            rangeMonthPlaceholder: ['Simulang buwan', 'Pangwakas na buwan'],
            rangeWeekPlaceholder: ['Simulang linggo', 'Pangwakas na linggo'],
            locale: 'fil_PH',
            today: 'Ngayon',
            now: 'Ngayon',
            backToToday: 'Bumalik sa ngayon',
            ok: 'OK',
            clear: 'Burahin',
            month: 'Buwan',
            year: 'Taon',
            timeSelect: 'Pumili ng oras',
            dateSelect: 'Pumili ng petsa',
            monthSelect: 'Pumili ng buwan',
            yearSelect: 'Pumili ng taon',
            decadeSelect: 'Pumili ng dekada',
            yearFormat: 'YYYY',
            dateFormat: 'D/M/YYYY',
            dayFormat: 'D',
            dateTimeFormat: 'D/M/YYYY HH:mm:ss',
            monthBeforeYear: true,
            previousMonth: 'Nakaraang buwan (PageUp)',
            nextMonth: 'Susunod na buwan (PageDown)',
            previousYear: 'Nakaraang taon (Control + kaliwa)',
            nextYear: 'Susunod na taon (Control + kanan)',
            previousDecade: 'Nakaraang dekada',
            nextDecade: 'Susunod na dekada',
            previousCentury: 'Nakaraang siglo',
            nextCentury: 'Susunod na siglo',
        },
        timePickerLocale: { placeholder: 'Pumili ng oras' },
    },
    global: { placeholder: 'Pakipili' },
    Table: {
        filterTitle: 'Menu ng filter',
        filterConfirm: 'OK',
        filterReset: 'I-reset',
        filterEmptyText: 'Walang filter',
        filterCheckall: 'Piliin lahat',
        filterSearchPlaceholder: 'Maghanap sa filter',
        emptyText: 'Walang datos',
        selectAll: 'Piliin lahat sa pahina',
        selectInvert: 'Baligtarin ang pagpili',
        selectNone: 'Tanggalin ang lahat ng pagpili',
        selectionAll: 'Piliin lahat ng datos',
        sortTitle: 'Pag-uriin',
        expand: 'Palawakin ang hilera',
        collapse: 'I-collapse ang hilera',
        triggerDesc: 'I-click upang ayusin ng pababa',
        triggerAsc: 'I-click upang ayusin ng pataas',
        cancelSort: 'I-click upang kanselahin ang pag-uuri',
    },
    Modal: { okText: 'OK', cancelText: 'Kanselahin', justOkText: 'OK' },
    Popconfirm: { okText: 'OK', cancelText: 'Kanselahin' },
    Transfer: {
        titles: ['', ''],
        searchPlaceholder: 'Maghanap dito',
        itemUnit: 'item',
        itemsUnit: 'mga item',
        remove: 'Tanggalin',
        selectCurrent: 'Piliin kasalukuyang pahina',
        removeCurrent: 'Tanggalin kasalukuyang pahina',
        selectAll: 'Piliin lahat ng datos',
        removeAll: 'Tanggalin lahat ng datos',
        selectInvert: 'Baligtarin kasalukuyang pahina',
    },
    Upload: {
        uploading: 'Nag-a-upload...',
        removeFile: 'Tanggalin ang file',
        uploadError: 'May error sa pag-upload',
        previewFile: 'Silipin ang file',
        downloadFile: 'I-download ang file',
    },
    Empty: { description: 'Walang Datos' },
    Icon: { icon: 'icon' },
    Text: { edit: 'I-edit', copy: 'Kopyahin', copied: 'Nakopya', expand: 'Palawakin' },
    Form: {
        /* eslint-disable no-template-curly-in-string */
        // These template placeholders are expected by antd
        optional: '(opsyonal)',
        defaultValidateMessages: {
            default: 'Error sa pagpapatunay ng field para sa ${label}',
            required: 'Pakilagay ang ${label}',
            enum: 'Ang ${label} ay dapat isa sa [${enum}]',
            whitespace: 'Ang ${label} ay hindi maaaring walang laman',
            date: {
                format: 'Maling format ng petsa para sa ${label}',
                parse: 'Ang ${label} ay hindi maaaring gawing petsa',
                invalid: 'Ang ${label} ay hindi wastong petsa',
            },
            types: {
                string: 'Ang ${label} ay hindi wastong ${type}',
                method: 'Ang ${label} ay hindi wastong ${type}',
                array: 'Ang ${label} ay hindi wastong ${type}',
                object: 'Ang ${label} ay hindi wastong ${type}',
                number: 'Ang ${label} ay hindi wastong ${type}',
                date: 'Ang ${label} ay hindi wastong ${type}',
                boolean: 'Ang ${label} ay hindi wastong ${type}',
                integer: 'Ang ${label} ay hindi wastong ${type}',
                float: 'Ang ${label} ay hindi wastong ${type}',
                regexp: 'Ang ${label} ay hindi wastong ${type}',
                email: 'Ang ${label} ay hindi wastong ${type}',
                url: 'Ang ${label} ay hindi wastong ${type}',
                hex: 'Ang ${label} ay hindi wastong ${type}',
            },
            pattern: { mismatch: 'Ang ${label} ay hindi tumutugma sa pattern ${pattern}' },
        },
    },
    Image: { preview: 'Silipin' },
}

export function getAntLocale(langugage: SupportedLanguage) {
    switch (langugage) {
        case 'de-DE':
            return de_DE
        case 'en-GB':
            return en_GB
        case 'es-ES':
            return es_ES
        case 'fr-FR':
            return frFR
        case 'pt-BR':
            return pt_BR
        case 'pt-PT':
            return pt_PT
        case 'it-IT':
            return it_IT
        case 'zh-CN':
            return zh_CN
        case 'ru-RU':
            return ru_RU
        case 'el-GR':
            return el_GR
        case 'sr-SP':
        case 'sr-Latn-RS':
            return sr_SP
        case 'lv-LV':
            return lv_LV
        case 'lt-LT':
            return lt_LT
        case 'et-EE':
            return et_EE
        case 'bg-BG':
            return bg_BG
        case 'km-KH':
            return km_KH
        case 'ja-JP':
            return ja_JP
        case 'uk-UA':
            return uk_UA
        case 'vi-VN':
            return vi_VN
        case 'nl-NL':
            return nl_NL
        case 'pl-PL':
            return pl_PL
        case 'cs-CZ':
            return cs_CZ
        case 'sk-SK':
            return sk_SK
        case 'hu-HU':
            return hu_HU
        case 'ro-RO':
            return ro_RO
        case 'hr-HR':
            return hr_HR
        case 'ms-MY':
            return ms_MY
        case 'fr-CA':
            return fr_CA
        case 'no-NO':
            return no_NO
        case 'tr-TR':
            return tr_TR
        case 'nl-BE':
            return nl_BE
        case 'kk-KZ':
            return kk_KZ
        case 'id-ID':
            return id_ID
        case 'ko-KR':
            return ko_KR
        case 'fil-PH':
            return fil_PH
        default:
            assumeExhaustion(langugage)
    }
}
